import {
    createLoadingSpinner,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { HtmlId } from '../enums/elementId';
import { createComponentById } from '@vfde-brix/ws10/core';

export const mountLoadingSpinner = (wrapperId: HtmlId, nested = false) =>
    createComponentById(createLoadingSpinner, wrapperId, {
        optNested: nested,
        optSize: 'medium',
        business: {},
    });

export const updateLoadingSpinner = (comp: LoadingSpinner | null, show: boolean) => {
    if (!comp) {
        return;
    }

    comp.toggleContainer(!show);
    comp.toggle(show);
};
